import { Button, Form, Input, Toast } from 'antd-mobile'
import React, { useState } from 'react'
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons'
import './index.css'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../app/providers/AuthProvider'
import { authApi } from '../features/auth/api/authApi'

export default function Login() {

  const [passwordHidden, setpasswordsHidden] = useState(false)

  const navigate = useNavigate()
  const { signIn } = useAuth()

  const formFinish = (values) => {
    Toast.show({
      icon: 'loading',
      content: '登录中',
      duration: 0,
    })
    authApi.login({
      phone: values.mobile,
      password: values.password
    })
      .then(function (response) {
        if (response.data.code === 200) {
          const token = response.headers['x-auth-token'] || response.data.data?.loginToken
          // 没有可持久使用的凭证时不能把本地资料误判为已完成登录。
          if (!token) {
            Toast.show({ icon: 'fail', content: '登录凭证获取失败，请刷新后重试' })
            return
          }
          Toast.show({
            icon: 'success',
            content: "登录成功！"
          })
          // 通过认证上下文更新登录态，让全局路由守卫立即生效。
          // 长期凭证随登录响应下发，后续操作无需依赖会过期的内存 Session。
          // 代理未透传自定义响应头时，使用登录响应体中的同一凭证。
          signIn(response.data.data, token)
          navigate('/home')
        } else if (response.data.code === 500) {
          Toast.show({
            icon: 'fail',
            content: response.data.msg
          })
        }
      })
      .catch(function (error) {
        console.error('Error fetching user list:', error);
        Toast.show({
          icon: 'fail',
          content: '登录失败，请检查网络'
        })
      })
  }

  const [form] = Form.useForm();

  return (
    <div className="login-container">
      {/* Dynamic Background Elements */}
      <div className="login-orb login-orb--1" />
      <div className="login-orb login-orb--2" />

      {/* Brand / Logo Section */}
      <div className="login-brand">
        <img
          className="login-brand-logo"
          src="https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/kplogo.png"
          alt="华西足球"
        />
        <h1 className="login-brand-title">华西科朋足球队</h1>
        <div className="login-brand-subtitle">Elite Football Experience</div>
      </div>

      {/* Exquisite Glass Card */}
      <div className="login-glass-card">
        <div className="login-card-header">
          <h2>欢迎回来</h2>
          <p className="login-access-note">本系统仅供球队内部成员使用，账号需联系管理员申请开通。</p>
          <div className="login-access-kicker">HUAXI SOCCER MEMBER ACCESS</div>
        </div>

        <Form
          form={form}
          layout='vertical'
          onFinish={values => formFinish(values)}
          requiredMarkStyle='none'
        >
          {/* Account Input */}
          <Form.Item
            name='mobile'
            className="stagger-1"
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <div className="login-input-wrapper">
              <span className="login-input-icon">📱</span>
              <Input
                placeholder='手机号 / 账号'
                style={{ flex: 1 }}
              />
            </div>
          </Form.Item>

          {/* Password Input */}
          <Form.Item
            name='password'
            className="stagger-2"
            rules={[{ required: true, message: '请输入密码' }]}
            valuePropName='value'
          >
            <div className="login-input-wrapper">
              <span className="login-input-icon">🔒</span>
              <Input
                style={{ flex: 1 }}
                placeholder='账户密码'
                type={passwordHidden ? 'text' : 'password'}
                onChange={(value) => {
                  form.setFieldsValue({ password: value });
                }}
              />
              <div
                className="login-password-toggle"
                onClick={() => setpasswordsHidden(!passwordHidden)}
              >
                {!passwordHidden ? <EyeInvisibleOutline /> : <EyeOutline />}
              </div>
            </div>
          </Form.Item>

          {/* Login Action */}
          <Button
            block
            type='submit'
            className='login-btn-primary stagger-3'
          >
            <span>立即登录</span>
            <i>→</i>
          </Button>
        </Form>

        {/* Guest Action */}
        <div className="stagger-4">
          <Button
            block
            className='login-btn-guest'
            onClick={() => {
              signIn({ temp: '1' })
              navigate('/home')
            }}
          >
            <span>以访客身份继续</span>
            <i>→</i>
          </Button>
        </div>

        {/* 备案信息放在登录卡片底部，保证域名审核时清晰可见。 */}
        <div className="login-footer">
          <div className="login-footer-beian">
            <img src={'https://gsrd-server.tos-cn-beijing.volces.com/beian.png'} alt="备案图标" />
            <a href='https://beian.miit.gov.cn/' target="_blank" rel="noreferrer">
              蜀ICP备2023029144号-2
            </a>
          </div>
          <div className="login-footer-copyright">
            © 2026 HUAXI FOOTBALL. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </div>
  )
}
